<div class="form-page-container">
  <app-steps></app-steps>
  <div class="wizard__wrapper container--padding">
    <div class="form-step">
      <ng-container [ngSwitch]="(currentStep | async)?.stepIndex">
        <ng-container *ngSwitchCase="1">
          <app-general-information-step
            #generalInformationStep
            [step]="currentStep | async"
            [generalInfoByLang]="generalInfoByLang"
            [experienceId]="experienceId"
            [comments]="comments"
            [hasIssue]="hasComments"
            [commentSchedule]="commentSchedule"
            [commentInfo]="commentInfo"
            [experienceOrigin]="experienceOrigin"
            [experienceOriginUrl]="experienceOriginUrl"
          ></app-general-information-step>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <app-location-step
            #locationStep
            [step]="currentStep | async"
            [generalInfoByLang]="generalInfoByLang"
            [experienceId]="experienceId"
            [comments]="comments"
            [hasIssue]="hasComments"
            [commentLocation]="commentLocation"
            [experienceOrigin]="experienceOrigin"
            [experienceOriginUrl]="experienceOriginUrl"
          ></app-location-step>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <app-images-step
            #imagesStep
            [step]="currentStep | async"
            [generalInfoByLang]="generalInfoByLang"
            [experienceId]="experienceId"
            [comments]="comments"
            [hasIssue]="hasComments"
            [commentImmage]="commentImmage"
            [experienceOrigin]="experienceOrigin"
            [experienceOriginUrl]="experienceOriginUrl"
          ></app-images-step>
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <app-finishing-touches-step
            [step]="currentStep | async"
            [generalInfoByLang]="generalInfoByLang"
            [experienceId]="experienceId"
            [hasIssue]="hasComments"
            [hasComments]="hasComments"
            [comments]="comments"
            [experienceOrigin]="experienceOrigin"
            [experienceOriginUrl]="experienceOriginUrl"
          ></app-finishing-touches-step>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="wizard__wrapper__controls container--padding">
    <button
      *ngIf="(currentStep | async)?.stepIndex > 1"
      type="button"
      (click)="onPrevStep()"
      class="button button--big"
    >
      {{ "Back" | translate }}
    </button>
    <button
      *ngIf="(currentStep | async)?.stepIndex != 4"
      type="button"
      (click)="onNextStep()"
      class="button button--purple button--big"
      [disabled]="!(currentStep | async)?.isComplete"
    >
      {{ "Next" | translate }}
    </button>
    <button
      *ngIf="(currentStep | async)?.stepIndex == 4"
      type="button"
      (click)="publishForApproval()"
      class="button button--purple button--big"
      [disabled]="!(currentStep | async)?.isComplete"
    >
      <span *ngIf="loader"
        ><span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        {{ "Loading" | translate }}</span
      ><span *ngIf="!loader">{{ "Publish" | translate }}</span>
    </button>
  </div>
</div>
